import { FaCode } from "react-icons/fa";
import { AiOutlineFullscreen, AiOutlineClose } from "react-icons/ai";
import ProjectPreview from "./ProjectPreview";

const ProjectModal = ({
  selectedProject,
  showCode,
  renderCodeViewer,
  handleCodeToggle,
  handleFullscreen,
  isFullscreen,
  closeModal,
}) => {
  if (!selectedProject) return null;
  return (
    <div className={`project-modal${isFullscreen ? " fullscreen" : ""}`}>
      <div className="project-modal-content">
        <div className="project-modal-header">
          <h3>{selectedProject.title}</h3>
          <div className="project-modal-controls">
            <button
              className="control-btn"
              onClick={handleCodeToggle}
              title="Toggle Code View"
            >
              <FaCode />
            </button>
            <button
              className="control-btn"
              onClick={handleFullscreen}
              title="Toggle Fullscreen"
            >
              <AiOutlineFullscreen />
            </button>
            <button
              className="control-btn close-btn"
              onClick={closeModal}
              title="Close"
            >
              <AiOutlineClose />
            </button>
          </div>
        </div>
        <div className="project-modal-body">
          {!showCode ? (
            <ProjectPreview selectedProject={selectedProject} />
          ) : (
            renderCodeViewer()
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
